import React from 'react';
import { Link, NavLink, useLocation, useNavigate } from 'react-router-dom';
import "./HamburgerOverlay.css";
import { analytics } from '../firebase/firebase'; // adjust your path
import { logEvent } from 'firebase/analytics'; // basic GA4 event logging

function HamburgerOverlay({
  isOpen,
  toggleOverlay,
  handleBuyPremiumClick,
  config,
  GoogleButton,
  handleLoginSuccess,
  handleLoginFailure,
  googleAuthRef
}) {
  const location = useLocation();
  const navigate = useNavigate();

  const links = [
    { to: '/', label: 'Home', icon: config.home },
    { to: '/blog', label: 'Blog', icon: config.blogimg },
    { to: '/privacy', label: 'Privacy Policy', icon: config.privacy },
    { to: '/refundpolicy', label: 'Refund Policy', icon: config.refundimg },
    { to: '/terms&condition', label: 'Terms & Condition', icon: config.termsimg },
  ];

  const handleLinkClick = (label) => {
    logEvent(analytics, 'hamburger_link_clicked_FacelessVideo', {
      link_name: label,
    });
  };

  const handleBuyPremiumClickWithTracking = () => {
    logEvent(analytics, 'hamburger_buy_premium_clicked_FacelessVideo', {
      button_name: 'Buy Premium Button',
    });

    toggleOverlay();
    navigate('/premium');
  };

  if (!isOpen) return null;

  return (
    <div className="overlay" onClick={toggleOverlay}>
      <div className="overlay-content" onClick={(e) => e.stopPropagation()}>
        <div className="topslider">
          <div className="close-icon" onClick={toggleOverlay}>
            &#10005;
          </div>
          <img src={config.frame} alt="Frame" className="frame" />
        </div>

        <div className="button-container-slider">
          <button
            className="buy-premium-slider"
            onClick={handleBuyPremiumClickWithTracking}
          >
            <img src={config.crown} alt="Crown" className="slidercrown" />{' '}
            3 Days Free Trial
          </button>

          <div className="buttonscrollonslider">
            {links.map(({ to, label, icon }) => (
              <NavLink
                key={to}
                to={to}
                onClick={() => {
                  handleLinkClick(label);
                  toggleOverlay(); // close overlay on link click
                }}
                className={({ isActive }) =>
                  `Home_btn_slider ${isActive ? 'active' : ''}`
                }
              >
                <span>
                  <img src={icon} alt={label} className="slider-Homeimg" />
                </span>{' '}
                {label}
              </NavLink>
            ))}
          </div>

          <GoogleButton
            ref={googleAuthRef}
            id="login_slider"
            onLoginSuccess={handleLoginSuccess}
            onLoginFailure={handleLoginFailure}
          />
        </div>
      </div>
    </div>
  );
}

export default HamburgerOverlay;
